export enum Roles {
  Admin = 'admin',
  Artist = 'artist',
  Player = 'player',
  None = '',
}
